<template>
    <div class="login-container">
        <div class="inner">
            <re-login></re-login>
        </div>
        <div class="footer">
            <p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">工业和信息化部备案管理系统网站
              鄂ICP备：10019046号</a></p>
            <p style='margin-top: 2px'>Copyright 2020 - 2022 武汉中科创伊宁智能设备公司.All Rights Reserved</p>
        </div>
    </div>
</template>

<script>
    import ReLogin from './login'
    export default {
        components: {
            ReLogin
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    $light_gray: #839aa5;

    /* reset element-ui css */
    .login-container {
        .inner {
            position: relative;
            margin: 120px auto;
            width: 700px;
            height: 505px;
        }

        .innerTop {
            position: absolute;
            display: inline-flex;
            top: 39px;
            left: 73px;
        }

        .logoImg {
            margin-right: 15px;
        }

        .sysName {
            font-size: 24px;
            font-family: FZZhengHeiS-DB-GB;
            color: rgba(239, 243, 252, 1);
            letter-spacing: 2px;
            font-weight: 500;
        }

        .el-input {
            display: inline-block;
            height: 47px;
            width: 85%;

            input {
                background: transparent;
                border: 0px;
                -webkit-appearance: none;
                border-radius: 0px;
                padding: 12px 5px 12px 15px;
                color: $light_gray;
                height: 47px;

                &:-webkit-autofill {
                    box-shadow: 0 0 0px 1000px rgb(255, 255, 255) inset !important;
                    -webkit-box-shadow: 0 0 0px 1000px rgb(255, 255, 255) inset !important;
                    -webkit-text-fill-color: #839aa5 !important;
                }
            }
        }

        .el-form-item {
            border: 1px solid #eee;
            background: #fff;
            border-radius: 5px;
            color: #454545;
            margin: 30px 0;
        }

        .loginBtn {
            margin-top: 65px;
            border: 0px;

            .el-button--small, .el-button--small.is-round {
                padding: 12px !important;
                font-size: 18px;
            }
        }

        .erweima {
            display: block;
            margin: 0 auto;
            padding: 22px;
            margin-top: 40px;
            background: linear-gradient(to left, #eee, #eee) left top no-repeat,
            linear-gradient(to bottom, #eee, #eee) left top no-repeat,
            linear-gradient(to left, #eee, #eee) right top no-repeat,
            linear-gradient(to bottom, #eee, #eee) right top no-repeat,
            linear-gradient(to left, #eee, #eee) left bottom no-repeat,
            linear-gradient(to bottom, #eee, #eee) left bottom no-repeat,
            linear-gradient(to left, #eee, #eee) right bottom no-repeat,
            linear-gradient(to left, #eee, #eee) right bottom no-repeat;
            background-size: 2px 20px, 20px 2px, 2px 20px, 20px 2px;
        }

        .wxLogin {
            text-align: center;
            margin-top: 21px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            color: rgba(0, 0, 0, 1);
            line-height: 33px;
        }
        .footer {
            color: #666;
            text-align: center;
            margin-left:  155px;
        }
    }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
    .login-container {
        position: fixed;
        height: 100%;
        width: 100%;
        //background: no-repeat url('../../assets/bg.png');
      background-color: #f0f2f5;
        background-size: cover;
    }
</style>
